import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Ertigacabbookinginpune() {



  const cardData =
  {
    keyword: 'Ertiga Cab Booking in Pune',
    heading: 'Sai Trupti Cabs: Ertiga Cab Booking in Pune',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable Ertiga cab booking in Pune, designed to make your local rides and out-station journeys smooth and stress-free. Our fleet includes well-maintained, air-conditioned Maruti Ertiga vehicles — all equipped with clean interiors, spacious 7-seater capacity, and ample luggage space. Every trip is managed by a professional, background-verified chauffeur who ensures punctual pickup anywhere in Pune, courteous service, and safe, smooth driving throughout your ride. With transparent rental fares (hourly, daily, one-way or round-trip), flexible booking options, and 24×7 customer support, Sai Trupti Cabs makes your Ertiga hire in Pune convenient, affordable and worry-free..',

    top: 'Top Places to Visit in Pune with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is the crown jewel of Pune’s Maratha heritage, built in 1732 by the Peshwas as the seat of their empire. Once a magnificent seven-storey palace, its grand gates, carved teak balconies, and sprawling courtyards reflect royal elegance and political power. Though much of it was destroyed by fire, the fort’s ruins still whisper tales of valor, intrigue, and sacrifice. The evening light-and-sound show revives the Peshwa era through mesmerizing narration and music. Shaniwar Wada remains the emotional heart of Pune — where history, culture, and pride unite."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace stands as an enduring symbol of India’s freedom movement and Mahatma Gandhi’s legacy. Built in 1892 by Sultan Aga Khan III, the palace later became a place of internment for Gandhi, Kasturba Gandhi, and other leaders during the Quit India Movement. The tranquil gardens, memorials, and museum preserve their memories and personal belongings. Its elegant Italian arches and serene ambiance make it both a historical monument and a place of reflection. Every corner tells a story of sacrifice, resilience, and the unbreakable spirit of India’s struggle for independence."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched atop the rugged Sahyadri ranges, Sinhagad Fort is a timeless symbol of Maratha courage and pride. The fort gained fame after the legendary battle led by Tanaji Malusare under the command of Chhatrapati Shivaji Maharaj. Trekking up its steep slopes rewards visitors with panoramic views of the valley and Pune city. The fort’s stone walls, ancient gates, and rustic stalls serving pithla-bhakri bring history to life. Sinhagad is not just a fortress — it’s an experience of heritage, adventure, and the indomitable spirit of the Marathas."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is a fascinating 8th-century rock-cut shrine carved from basalt, dedicated to Lord Shiva. Located in the heart of Pune, it offers a peaceful escape from city noise and chaos. The circular Nandi mandapa, massive stone pillars, and unfinished sanctum reflect remarkable ancient craftsmanship. Believed to have been excavated during the Rashtrakuta dynasty, the temple’s spiritual aura attracts devotees and historians alike. Amid modern Pune’s growth, Pataleshwar stands as a reminder of its deep and timeless spiritual roots."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill rises gracefully over Pune, offering both divine blessings and breathtaking views. The temple complex atop the hill is dedicated to Lord Shiva and Goddess Parvati and was built by the Peshwas in the 18th century. Climbing its 108 stone steps is both a spiritual and meditative experience, rewarded by panoramic views of the city below. The site also houses the Peshwa Museum, which preserves rare artifacts of Maratha glory. At sunrise and sunset, Parvati Hill becomes a golden haven of peace, history, and devotion."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Dagdusheth Halwai Ganpati Temple is Pune’s most beloved spiritual landmark, drawing millions of devotees each year. The temple’s magnificent idol of Lord Ganesha, adorned with gold ornaments and fresh flowers, radiates devotion and positivity. During Ganesh Chaturthi, the entire area transforms into a festival of lights, music, and prayer. The temple also supports charitable causes, embodying the true essence of faith in action. Whether you visit for blessings or simply to soak in its energy, Dagdusheth Temple fills every heart with peace and joy."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure house of Indian art and tradition, housing over 20,000 artifacts collected by the late Dr. Dinkar Kelkar. Its exhibits include intricate musical instruments, ancient sculptures, traditional ornaments, and everyday objects that reveal India’s creative spirit. The museum’s highlight is the replica of a 17th-century Wada — a traditional Maharashtrian mansion. Walking through its corridors feels like stepping back in time. It’s a must-visit for art lovers, history enthusiasts, and anyone seeking to rediscover India’s cultural richness."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, just 20 km from Pune, is a popular getaway surrounded by rolling hills and lush greenery. Built across the Mutha River, it serves as the city’s primary water source and a serene picnic spot for families and friends. Visitors enjoy the mesmerizing sunset reflecting off the calm waters while savoring local snacks from nearby stalls. During monsoon, the dam’s scenic charm doubles, making it a photographer’s paradise. It’s the perfect escape for those seeking peace, nature, and a cool breeze away from urban life."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, Osho International Meditation Resort is a tranquil oasis that attracts visitors from across the globe. Spread over lush gardens and modern Zen-inspired architecture, it offers various meditation sessions, wellness therapies and workshops on mindfulness. The serene environment encourages introspection and personal growth. Beyond being a retreat, Osho Resort reflects Pune’s cosmopolitan identity — blending spirituality, modernity, and holistic living. It’s where silence meets luxury, creating an experience that rejuvenates both body and soul."
  },
  {
    "title": "Pune Okayama Friendship Garden (Pu La Deshpande Udyan)",
    "description": "Inspired by Japan’s famous Korakuen Garden, the Pune Okayama Friendship Garden — also known as Pu La Deshpande Udyan — is an exquisite symbol of Indo-Japanese friendship. Spread across 10 acres, its winding paths, small bridges, ponds, and manicured lawns create a serene landscape ideal for relaxation and photography. The garden’s harmony between Japanese design and Indian flora makes it one of Pune’s most aesthetic green spaces. Families, nature lovers, and photographers visit to unwind amid its calming beauty and artistic symmetry."
  }
],



"services": [
  {
    "name": "Ertiga Cab Booking in Pune",
    "description": "Convenient Ertiga cab booking service in Pune offering AC and Non-AC options, professional drivers, luggage assistance, and flexible pickup/drop points. Ideal for city travel, airport transfers, family trips, corporate use, and outstation journeys, ensuring comfort, safety, and hassle-free travel."
  },
  {
    "name": "Ertiga Hire Pune",
    "description": "Reliable Ertiga hire service in Pune with AC and Non-AC vehicles, experienced drivers, luggage support, and flexible scheduling. Perfect for corporate trips, family outings, weddings, and long-distance travel, offering a comfortable and secure ride at competitive rates."
  },
  {
    "name": "AC Ertiga Pune",
    "description": "Comfortable AC Ertiga rental in Pune with professional drivers, luggage support, and multiple pickup/drop options. Suitable for airport transfers, corporate trips, family travel, and outstation journeys, providing a relaxing and cool travel experience."
  },
  {
    "name": "Non AC Ertiga Pune",
    "description": "Budget-friendly Non-AC Ertiga hire in Pune with professional drivers, luggage assistance, and flexible scheduling. Ideal for city rides, corporate trips, family outings, and long-distance journeys, offering safe, reliable, and economical transportation."
  },
  {
    "name": "Luxury Ertiga Pune",
    "description": "Premium luxury Ertiga rental in Pune with AC, top-quality interiors, professional chauffeurs, and luggage support. Perfect for weddings, VIP travel, corporate events, and special occasions, ensuring a stylish, comfortable, and safe journey."
  },
  {
    "name": "Corporate Ertiga Hire Pune",
    "description": "Specialized corporate Ertiga rental service in Pune with AC vehicles, experienced drivers, luggage assistance, and flexible schedules. Ideal for business trips, client meetings, and team travel, providing punctual, safe, and professional transportation."
  },
  {
    "name": "Wedding Ertiga Pune",
    "description": "Luxury Ertiga service in Pune for weddings with AC/Non-AC options, professional drivers, luggage support, and timely pickups. Perfect for transporting family members, guests, or VIPs, offering comfort, safety, and stylish travel for special occasions."
  },
  {
    "name": "Outstation Ertiga Pune",
    "description": "Reliable outstation Ertiga service from Pune with AC/Non-AC vehicles, professional chauffeurs, luggage support, and flexible pickup/drop schedules. Ideal for weekend getaways, long-distance travel, and corporate trips, ensuring comfort, safety, and timely arrivals."
  },
  {
    "name": "Ertiga One Way Cab Pune",
    "description": "Convenient one-way Ertiga cab service in Pune with AC/Non-AC options, professional drivers, luggage support, and transparent pricing. Suitable for airport transfers, long-distance drop-offs, and point-to-point travel, offering a smooth and hassle-free journey."
  },
  {
    "name": "Affordable Ertiga Cab Pune",
    "description": "Cost-effective Ertiga rental service in Pune with AC/Non-AC vehicles, professional chauffeurs, luggage support, and flexible schedules. Perfect for family trips, corporate travel, city rides, and long-distance journeys, providing safe, reliable, and economical transportation."
  },
  {
    "name": "Ertiga Online Booking Pune",
    "description": "Book your Ertiga in Pune online instantly with secure payments, multiple vehicle options, professional drivers, and luggage assistance. Ideal for last-minute bookings, planned trips, and outstation travel, ensuring a smooth, comfortable, and safe ride."
  },
  {
    "name": "Ertiga Rental Pune",
    "description": "Reliable Ertiga rental service in Pune with AC/Non-AC vehicles, professional drivers, luggage support, and flexible scheduling. Suitable for family trips, corporate travel, weddings, and long-distance journeys, providing a safe and comfortable travel experience."
  },
  {
    "name": "Ertiga 7 Seater Hire Pune",
    "description": "Spacious 7-seater Ertiga rental in Pune with AC/Non-AC options, professional drivers, luggage support, and flexible pickup/drop schedules. Ideal for family trips, small groups, corporate travel, and airport transfers, offering comfortable and safe transportation."
  },
  {
    "name": "Pune Ertiga Tour Cab",
    "description": "Tour-friendly Ertiga cab service in Pune with AC/Non-AC options, professional drivers, luggage support, and flexible itineraries. Perfect for sightseeing tours, family outings, corporate trips, and weekend getaways, providing convenience, comfort, and timely travel."
  },
  {
    "name": "Premium Ertiga Pune",
    "description": "Premium Ertiga rental service in Pune with AC, high-quality interiors, professional chauffeurs, luggage support, and flexible pickup/drop locations. Suitable for weddings, VIP travel, corporate trips, and special occasions, offering a luxurious, safe, and stylish journey."
  }
],
"tableData": [
  ["Ertiga Cab Booking in Pune", "Ertiga Hire Pune"],
  ["AC Ertiga Pune", "Non AC Ertiga Pune"],
  ["Luxury Ertiga Pune", "Corporate Ertiga Hire Pune"],
  ["Wedding Ertiga Pune", "Outstation Ertiga Pune"],
  ["Ertiga One Way Cab Pune", "Affordable Ertiga Cab Pune"],
  ["Ertiga Online Booking Pune", "Ertiga Rental Pune"],
  ["Ertiga 7 Seater Hire Pune", "Pune Ertiga Tour Cab"],
  ["Premium Ertiga Pune", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Ertiga Cab Booking in Pune",
    "WhyChoosedescription": "Sai Trupti Cabs  offers reliable and comfortable Ertiga cab services in Pune — ideal for city travel, airport transfers, corporate trips, and family outings."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Get clear and affordable rates for Ertiga cab bookings in Pune — no hidden charges, with options for hourly, daily, or outstation rides."
  },
  {
    "WhyChooseheading": "Flexible Booking Options",
    "WhyChoosedescription": "Book an Ertiga cab for short city trips, long-distance travel, or full-day rentals according to your travel requirements."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained and courteous drivers ensure a safe, smooth, and timely journey for every Ertiga cab ride in Pune."
  },
  {
    "WhyChooseheading": "Convenient Pickup & Drop",
    "WhyChoosedescription": "We offer flexible pickups and drop-offs across Pune, including airports, railway stations, hotels, and residential areas."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "All Ertiga cabs are regularly serviced, sanitized, and maintained to provide comfort, safety, and reliability during your ride."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with bookings, route planning, or any travel queries."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Ertiga cab in Pune easily via call, WhatsApp, or our website — with instant confirmation and prompt vehicle dispatch."
  }
]






















  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer Ertiga cab bookings in Pune?',
    answer: 'Yes, Sai Trupti Cabs  provides reliable and affordable Ertiga cab bookings in Pune for local trips, one-way, round trips, and outstation travel.',
  },
  {
    question: 'How can I book an Ertiga cab in Pune with Sai Trupti Cabs?',
    answer: 'You can easily book an Ertiga cab in Pune through our website, mobile app, or by contacting our 24×7 customer support team for instant confirmation.',
  },
  {
    question: 'What types of trips can I take with an Ertiga cab in Pune?',
    answer: 'Our Ertiga cabs can be hired for local travel, airport transfers, corporate trips, sightseeing tours, one-way or round trips, and outstation journeys.',
  },
  {
    question: 'Are the drivers experienced for Ertiga cab bookings in Pune?',
    answer: 'Yes, all our drivers are professional, courteous, and trained for both city and long-distance travel, ensuring a safe and comfortable journey.',
  },
  {
    question: 'Can I hire an Ertiga cab in Pune for family or group travel?',
    answer: 'Certainly. Our Ertiga cab service is ideal for family trips, group outings, and corporate travel, accommodating up to 6 passengers comfortably.',
  },
  {
    question: 'Is the Ertiga cab service available 24×7 in Pune?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 Ertiga cab services in Pune for your convenience and flexible scheduling.',
  },
  {
    question: 'What are the fares for Ertiga cab bookings in Pune?',
    answer: 'Fares start from approximately ₹1,200 for local trips and ₹1,800–₹2,500 for outstation or longer trips, depending on distance, duration, and travel requirements.',
  },
  {
    question: 'What payment methods are accepted for Ertiga cab bookings in Pune?',
    answer: 'We accept payments via UPI, credit/debit cards, bank transfers, and digital wallets for secure and hassle-free transactions.',
  },
  {
    question: 'What safety and hygiene measures are followed for Ertiga cab bookings in Pune?',
    answer: 'All Ertiga vehicles are sanitized before every trip, and our drivers follow strict safety and hygiene protocols for a secure journey.',
  },
  {
    question: 'Is customer support available during the Ertiga cab journey in Pune?',
    answer: 'Yes, our 24×7 customer support team is available to assist you before, during, and after your Ertiga cab journey in Pune.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Saurabh Kulkarni',
    feedback: 'Booking an Ertiga cab from Sai Trupti Cabs in Pune was very smooth. Comfortable vehicle and professional driver.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priyanka Deshmukh',
    feedback: 'Sai Trupti Cabs provided excellent Ertiga cab service in Pune. The booking process was easy and the ride was comfortable.',
    rating: 5,
  },
];









































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Ertiga Cab Booking in Pune",
  "image": "https://saitrupticabs.com/assets/images/ertiga-pune.jpg",
  "description": "Book an Ertiga cab in Pune with Sai Trupti Cabs. Choose AC or Non-AC, luxury options for corporate trips, weddings, outstation travel, and one-way rentals. Affordable Ertiga hire with online booking available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "1620"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2500",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/ertiga-cab-booking-pune"
  }
};






  return (
    <div>
      
<Helmet>
  <title>Ertiga Cab Booking in Pune | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book an Ertiga cab in Pune with Sai Trupti Cabs. Choose AC or Non-AC, luxury options for corporate trips, weddings, outstation travel, and one-way rentals. Affordable Ertiga hire with online booking available 24x7." 
  />
  <meta 
    name="keywords" 
    content="Ertiga Cab Booking in Pune, Ertiga Hire Pune, AC Ertiga Pune, Non AC Ertiga Pune, Luxury Ertiga Pune, Corporate Ertiga Hire Pune, Wedding Ertiga Pune, Outstation Ertiga Pune, Ertiga One Way Cab Pune, Affordable Ertiga Cab Pune, Ertiga Online Booking Pune, Ertiga Rental Pune, Ertiga 7 Seater Hire Pune, Pune Ertiga Tour Cab, Premium Ertiga Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/49.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Ertigacabbookinginpune;